import {Component, inject, Injector} from '@angular/core';
import {RetranslationService} from "../../../../services/retranslation.service";
import {BaseAdminPanelComponent} from "../../base-admin-panel/base-admin-panel.component";
import {Observable} from "rxjs";
import {CreateRetranslatorComponent} from "../create-retranslator.component";
import {RetranslationStatus, RetranslationViewModel} from "../Models/RetranslationViewModel";
import {EditRetranslatorComponent} from "../edit-retranslator.component";
import {Protocol} from "../Models/Protocols";

@Component({
    selector: '[app-retranslators]',
    templateUrl: './retranslators.component.html',
    styleUrls: ['./retranslators.component.css'],
    standalone: false
})
export class RetranslatorsComponent extends BaseAdminPanelComponent {
  protected retranslationService: RetranslationService = inject(RetranslationService);

  protected formatDate(ms: number): string {
    const date = new Date(ms);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yy = String(date.getFullYear() % 100).padStart(2, '0');
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    return `${dd}.${mm}.${yy}`;
  }

  constructor(protected injector: Injector)
  {
    super(injector);
    this.entityName = "Retranslations";
  }

  protected Refresh() {
    this.retranslationService.GetRetranslations()
      .subscribe(retranslations => {
        this.objects = retranslations;
      });
  }


  protected doDeleteObject(id: number): Observable<any>
  {
    return this.retranslationService.DeleteRetranslation(id);
  }

  public openCreateModal() {
    this.prepareModal(CreateRetranslatorComponent);
    let retranslation: RetranslationViewModel = new RetranslationViewModel();
    retranslation.From = Date.now();
    this.componentRef.instance.open(retranslation);
  }

  public openEditModal(command: RetranslationViewModel) {
    this.prepareModal(EditRetranslatorComponent);
    this.componentRef.instance.open(command);
  }

  protected readonly Protocol = Protocol;
  protected readonly RetranslationStatus = RetranslationStatus;
}
